module.exports = __webpack_public_path__ + "static/img/look.f6290e33.jpg";